module.exports = __webpack_public_path__ + "img/menu-logo.f4b31e07.svg";